import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter } from 'react-router-dom';
import AuthProvider from './contexts/auth';
import { UploadProgressProvider } from './contexts/UploadProgressProvider';
import { ToastContainer } from 'react-toastify';
import Routeses from './routes/routes';

function App() {
  return (
    <UploadProgressProvider>
      <AuthProvider>
        <BrowserRouter>
          <ToastContainer autoClose={3000} />
          <Routeses />
        </BrowserRouter>
      </AuthProvider>
    </UploadProgressProvider>
  );
}

export default App;
